/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_BOXES } from "../graphql/getBoxes.query";
import { GET_DIST_BOX } from "../graphql/getDistBox.query";
import { GET_BOXES_ONE } from "../graphql/getBoxesOne.query";
import appCardConfig from "../config/appCard.config.json";
import header from "../config/header.config.json";
import moment from "moment-timezone";
import { toHeaderCase } from "js-convert-case";
import { CurrencyConversion } from "../../../common";
import * as changeCase from "change-case";
import { useState } from "react";
const is = require("is_js");
const isVideo: any = /\.(mp4|mov|avi|avchd|flv|f4v|swf|mkv|webm|html5)$/i;
const isYoutubeVideo: any =
  /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/i;
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
export interface IGetBoxesMethods extends IPluginMethodMap {
  getBoxes(args: any): Promise<any>;
  getBoxesOne(args: any): Promise<any>;
}
export class GetBoxesService implements IAgentPlugin {
  readonly methods: IGetBoxesMethods;
  private exchangeRate: any = 1;
  constructor() {
    this.methods = {
      getBoxesOne: this.getBoxesOne.bind(this),
      getBoxes: this.getBoxes.bind(this),
    };
  }
  async getBoxesOne(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("getboxes1", args);
    let costumeId = args?.costumeID ?? args?.costumeId;
    console.log(args);
    // let boxFilter = {
    //   ...(args?.userId && { user: { eq: args.userId } }),
    //   ...(args?.isCostumeId &&
    //     args?.costumeID && { costumeID: { eq: args.costumeID } }),
    // };
    let boxFilter = {
      ...(args?.id &&
        args?.prevPage !== "DeliveredReport" && { _id: { eq: args.id } }),
      ...(args?.userId && { user: { eq: args.userId } }),
      ...(args?.isCostumeId && costumeId && { costumeID: { eq: costumeId } }),
    };
    try {
      if (client && Object.keys(boxFilter).length > 0) {
        const res = await client.query({
          query: GET_BOXES_ONE,
          variables: {
            filter: boxFilter,
            options: {
              sort: {
                field: "createdAt",
                order: "desc",
              },
              skip: 0,
              limit: 10,
            },
          },
          fetchPolicy: "no-cache",
        });
        this.exchangeRate = res?.data?.getCurrencyExchangeRate?.conversion_rate;
        if (
          res?.data?.getBoxes?.content &&
          is.not.empty(res?.data?.getBoxes?.content)
        ) {
          const payload = this.formatDataOne(res?.data?.getBoxes?.content[0]);
          return {
            ...payload,
          };
        }
      }
      return [];
      // }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
  async getBoxes(args: any) {
    console.log(args, "gj68 getBoxes");
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let costumeId = args?.costumeID ?? args?.costumeId;
    let boxFilter = {
      //   ...(args?.userId && { user: { eq: args.userId } }),
      //   ...(args?.isCostumeId &&
      //     args?.costumeId && { costumeID: { eq: args.costumeId } }),
      // };
      ...(args?.id &&
        args?.prevPage !== "DeliveredReport" && { _id: { eq: args.id } }),
      ...(args?.userId && { user: { eq: args.userId } }),
      ...(args?.isCostumeId && costumeId && { costumeID: { eq: costumeId } }),
    };
    let distboxFilter = {
      ...(args?.id && args?.prevPage !== "DeliveredReport" && { _id: args.id }),
      ...(args?.isCostumeId && costumeId && { costumeID: costumeId }),
    };
    let boxFilterPast = {
      ...(args?.userId && { user: { eq: args.userId } }),
    };
    console.log(Object.keys(boxFilter).length, "boxFilter78 getBoxes");
    try {
      console.log(boxFilter);
      console.log(boxFilterPast);
      console.log(distboxFilter);
      if (client && Object.keys(boxFilter).length > 0) {
        const res = await client.query({
          query: GET_BOXES,
          variables: {
            filter: boxFilter,
            options: {
              sort: {
                field: "createdAt",
                order: "desc",
              },
              skip: 0,
              limit: 10,
            },
          },
          fetchPolicy: "no-cache",
        });
        let hasDistBox = false;
        let scheduleID = null;
        try {
          const res1 = await client.query({
            query: GET_DIST_BOX,
            variables: { filter: distboxFilter },
            fetchPolicy: "no-cache",
            errorPolicy: "all",
          });

          if (res1?.errors?.length) {
            hasDistBox = false;
          } else if (res1?.data?.getDistBox) {
            hasDistBox = true;
            scheduleID = res1?.data?.getDistBox?.schedule;
          }
        } catch (e) {
          hasDistBox = false;
        }
        let payload2;
        if (Object.keys(boxFilterPast).length) {
          const resPast = await client.query({
            query: GET_BOXES,
            variables: {
              filter: boxFilterPast,
              options: {
                sort: {
                  field: "createdAt",
                  order: "desc",
                },
                skip: 0,
                limit: 10,
              },
            },
            fetchPolicy: "no-cache",
          });
          payload2 = this.formatDataPast(resPast?.data?.getBoxes?.content);
        }

        this.exchangeRate = res?.data?.getCurrencyExchangeRate?.conversion_rate;

        if (
          res?.data?.getBoxes?.content &&
          is.not.empty(res?.data?.getBoxes?.content)
        ) {
          console.log(
            "res?.data?.getBoxes?.content[0]",
            res?.data?.getBoxes?.content[0],
          );
          const payload1 = this.formatData(
            res?.data?.getBoxes?.content[0],
            res?.data?.getBoxes?.content,
            scheduleID,
          );
          console.log("res?.data?.getBoxes?.content[0]", payload1);
          return {
            ...payload1,
            ...payload2,
          };
        }
        return [];
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
  private getUserName(data: any) {
    if (data?.firstName) {
      return `${toHeaderCase(data?.firstName)} ${toHeaderCase(
        data?.lastName ?? " ",
      )}`;
    }
  }
  private pushListItem = (
    listItems: any,
    index: number,
    title: string,
    subtitle: string,
  ) => {
    if (subtitle && is.existy(subtitle)) {
      listItems.push({
        key: index.toString(),
        icon: appCardConfig?.listItems?.icon,
        title: title,
        subtitle: subtitle,
      });
    }
    return listItems;
  };
  private getListItems = (data: any) => {
    console.log("data==========", data);
    const invitedBy = data?.Referal?.invitedBy;
    const fullName = [invitedBy?.firstName, invitedBy?.lastName]
      .filter(Boolean)
      .join(" ");
    const label = fullName || invitedBy?.email;
    let listItems: any = [];
    let index = 0;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.fullName,
      this.getUserName(data?.user) ?? "",
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.email,
      data?.user?.email ?? "",
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.presentationName,
      data?.presentation?.name,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.sectionName,
      data?.section?.name,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.committee,
      label ?? "Lost Tribe Masq Camp"
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.costumeID,
      data?.costumeID,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.masqID,
      data?.user?.vuid,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.paymentStatus,
      data?.paymentStats,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.totalAmount,
      `TT$ ${data?.totalAmount} / US$ ${data?.totalAmountInUSD}`,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.receivedAmount,
      `TT$ ${data?.amountPaid.toFixed(2) ?? 0} / US$ ${
        data?.amountPaidInUSD ?? 0
      }`,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.remainingAmount,
      `TT$ ${(data?.totalAmount - (data?.amountPaid ?? 0))
        .toFixed(2)
        .toString()} / US$ ${(
        data?.totalAmountInUSD - (data?.amountPaidInUSD ?? 0)
      )
        .toFixed(2)
        .toString()}`,
    );
    index++;
    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.delegateName,
      data?.delegateName,
    );
    index++;
    return listItems;
  };
  private getAllSectionImages = (costumeType: any) => {
    let imagesArr: any = [];
    if (
      costumeType?.images &&
      is.existy(costumeType?.images) &&
      is.not.empty(costumeType?.images)
    ) {
      for (let obj of costumeType?.images) {
        if (obj && is.existy(obj)) {
          if (isVideo.test(obj)) {
            imagesArr.push({
              type: "video",
              src: obj,
            });
          } else if (isYoutubeVideo.test(obj)) {
            imagesArr.push({
              type: "video",
              src: obj,
            });
          } else {
            imagesArr.push({
              type: "img",
              src: obj,
            });
          }
        }
      }
    }
    return imagesArr;
  };
  private getTableData = (payload: any, data: any) => {
    if (!data) {
      return null;
    }
    let arrayItems: any = [];
    let index = 0;
    data?.map((item: any) => {
      if (item && is.existy(item) && is.not.empty(item)) {
        arrayItems.push({
          key: index,
          option: item?.costumeFeature?.name ?? "-",
          attribute: item?.costumeAttribute?.name ?? "-",
          value: item?.costumeValue?.name ?? "-",
          images: item?.costumeValue?.images ?? [],
          cost: item?.costumeValue?.topupPrice ?? "-",
        });
        index++;
      }
    });
    arrayItems.push({
      key: index,
      option: "Total",
      attribute: "",
      value: "",
      images: [],
      cost: `TT$ ${payload?.totalAmount} / US$ ${CurrencyConversion(
        this.exchangeRate,
        payload?.totalAmount,
      )}`,
    });
    return {
      ...appCardConfig?.table,
      data: arrayItems,
    };
  };
  private getInvoiceData = (data: any) => {
    let arrayItems: any = [];
    let index = 0;
    const _getPaymentMode = (item: any) => {
      if (is.existy(item?.payMethod) && is.existy(item?.mode)) {
        return item?.payMethod + " / " + item?.mode;
      } else if (is.existy(item?.payMethod)) {
        return item?.payMethod;
      } else if (is.existy(item?.mode)) {
        return item?.mode;
      } else {
        return "-";
      }
    };
    const addTxnsId = (status: any, id: any) => {
      return status + "///" + id;
    };
    data?.map((item: any) => {
      console.log(item);
      if (item && is.existy(item) && is.not.empty(item)) {
        arrayItems.push({
          key: index,
          date: moment(item?.createdAt).format("MMM D, YYYY, h:mm:ss A") ?? "",
          mode: addTxnsId(_getPaymentMode(item), item?.id),
          amount: `TT$ ${item?.amount} / US$ ${CurrencyConversion(
            this.exchangeRate,
            item?.amount,
          )}`,
          status: addTxnsId(item?.status, item?.txId) ?? "-",
          reason: item?.errorMessage ?? item?.resolutionStatus,
          handler: item?.handler,
          notes: item?.notes?.[0],
        });
        index++;
      }
    });
    arrayItems = arrayItems.sort((a: any, b: any) => {
      return new Date(b.date) - new Date(a.date);
    });
    return {
      ...appCardConfig?.invoice,
      data: arrayItems,
    };
  };
  private getJourneyChildData(item: any) {
    const data: any = [];
    let index: number = 0;
    console.log("itemitemitemitem=====", item);
    if (
      item?.actionContent?.deliveredBy &&
      is.existy(item?.actionContent?.deliveredBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.deliveredBy,
        subTitle: item?.actionContent?.deliveredBy,
      });
    } else if (
      item?.action &&
      item?.action === "transferred_costume" &&
      item?.actionContent?.OldUser &&
      is.existy(
        item?.actionContent?.OldUser?.firstName ||
          item?.actionContent?.OldUser?.lastName ||
          item?.actionContent?.OldUser?.email,
      )
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.from,
        subTitle:
          item?.actionContent?.OldUser?.firstName &&
          item?.actionContent?.OldUser?.lastName
            ? `${item?.actionContent?.OldUser?.firstName} ${item?.actionContent?.OldUser?.lastName}`
            : item?.actionContent?.OldUser?.firstName
            ? item?.actionContent?.OldUser?.firstName
            : item?.actionContent?.OldUser?.lastName
            ? item?.actionContent?.OldUser?.lastName
            : item?.actionContent?.OldUser?.email,
      });
    } else if (
      item?.action &&
      item?.action === "transferred_costume" &&
      item?.actionContent?.NewUser &&
      is.existy(
        item?.actionContent?.NewUser?.firstName ||
          item?.actionContent?.NewUser?.lastName ||
          item?.actionContent?.NewUser?.email,
      )
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.to,
        subTitle:
          item?.actionContent?.NewUser?.firstName &&
          item?.actionContent?.NewUser?.lastName
            ? `${item?.actionContent?.NewUser?.firstName} ${item?.actionContent?.NewUser?.lastName}`
            : item?.actionContent?.NewUser?.firstName
            ? item?.actionContent?.NewUser?.firstName
            : item?.actionContent?.NewUser?.lastName
            ? item?.actionContent?.NewUser?.lastName
            : item?.actionContent?.NewUser?.email,
      });
    } else if (
      item?.actionContent?.purgedBy &&
      is.existy(item?.actionContent?.purgedBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.purgedBy,
        subTitle: item?.actionContent?.purgedBy,
      });
    } else if (
      item?.actionContent?.generatedBy &&
      is.existy(item?.actionContent?.generatedBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.generatedBy,
        subTitle: item?.actionContent?.generatedBy,
      });
    } else if (
      this.getUserName(item?.user) &&
      is.existy(this.getUserName(item?.user))
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.by,
        subTitle: this.getUserName(item?.user) ?? "",
      });
    }
    if (item?.actionContent?.currency) {
      let str = "";
      if (
        item?.actionContent?.actualPayment?.currency !==
          item?.actionContent?.currency &&
        is.existy(item?.actionContent?.actualPayment?.currency) &&
        is.existy(item?.actionContent?.currency)
      ) {
        str = `US$ ${
          item?.actionContent?.actualPayment?.amount ?? "0.00"
        } / TT$ ${item?.actionContent?.amount ?? "0.00"}`;
      } else {
        str = `TT$ ${item?.actionContent?.amount ?? "0.00"}`;
      }
      data.push({
        key: index++,
        title: appCardConfig?.journey?.amount,
        subTitle: str,
      });
    }
    const _getReason = () => {
      if (
        is.existy(item?.reason) &&
        is.existy(item?.actionContent?.resolutionStatus)
      ) {
        return item?.reason + " / " + item?.actionContent?.resolutionStatus;
      } else if (is.existy(item?.actionContent?.resolutionStatus)) {
        return item?.actionContent?.resolutionStatus;
      } else if (is.existy(item?.reason)) {
        return item?.reason;
      }
    };
    if (_getReason() && is.existy(_getReason())) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.reason,
        subTitle: _getReason(),
      });
    }
    if (item?.actionContent?.reason && is.existy(item?.actionContent?.reason)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.reason,
        subTitle: item?.actionContent?.reason,
      });
    }
    if (
      item?.actionContent?.payMethod &&
      is.existy(item?.actionContent?.payMethod)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.method,
        subTitle: item?.actionContent?.payMethod,
      });
    }
    if (item?.actionContent?.mode && is.existy(item?.actionContent?.mode)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.mode,
        subTitle: item?.actionContent?.mode,
      });
    }
    if (item?.actionContent?.status && is.existy(item?.actionContent?.status)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.status,
        subTitle: item?.actionContent?.status,
      });
    }
    if (
      item?.actionContent?.deliveredTo &&
      is.existy(item?.actionContent?.deliveredTo)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.deliveredTo,
        subTitle: item?.actionContent?.deliveredTo,
      });
    }
    return data;
  }
  private addCollectorImage(item: any) {
    if (
      item?.actionContent?.imageUrl &&
      is.existy(item?.actionContent?.imageUrl)
    ) {
      return [
        {
          type: "img",
          src: item?.actionContent?.imageUrl,
        },
      ];
    }
    return null;
  }
  private getJourneyData = (data: any) => {
    let arrayItems: any = [];
    let index = 0;
    data &&
      data.map((item: any) => {
        if (item && is.existy(item) && is.not.empty(item)) {
          arrayItems.push({
            key: index,
            headline:
              item?.displayTitle ?? changeCase.capitalCase(item?.action),
            headlineBackgroundColor: appCardConfig?.journey?.backgroundColor,
            date: moment(item?.createdAt).format("MMMM Do YYYY, h:mm:ss a"),
            children: [
              {
                title:
                  item?.displayTitle ?? changeCase.capitalCase(item?.action),
                subtitle: moment(item?.createdAt).format("lll") ?? "",
                multiColList: {
                  numberOfColumns: "2",
                  data: this.getJourneyChildData(item),
                },
                carouselItems: this.addCollectorImage(item),
                carouselStyles: {
                  width: "140px",
                  height: "180px",
                },
              },
            ],
          });
          index++;
        }
      });
    arrayItems = arrayItems.sort((a: any, b: any) => {
      return new Date(b.date) - new Date(a.date);
    });
    return {
      ...appCardConfig?.journey,
      data: arrayItems.reverse(),
    };
  };
  private initialData(data: any) {
    return {
      isVIP: data?.isVIP,
      isMagic: data?.isMagic ?? false,
      isOpted: data?.delivery?.isOpted,
      deliveryOptions: header?.options,
      partner: data?.delivery?.partner,
      status: data?.delivery?.status,
      trackingId: data?.delivery?.trackingId,
      cityName: data?.user?.mailAddress?.city,
      address:
        data?.user?.mailAddress?.addressLine1 ??
        data?.user?.address?.addressLine1,
      delegateName: data?.delegateName,
    };
  }
  private formatDataOne(data: any) {
    let accordionItems: any = [];
    if (is.not.empty(this.getJourneyData(data?.boxTxes)?.data)) {
      accordionItems.push(this.getJourneyData(data?.boxTxes));
    }
    const buttons =
      data?.delivery?.status === "Delivered"
        ? []
        : data?.discount?.lateAssociation
        ? appCardConfig?.appCard?.assignEmailButtons
        : appCardConfig?.appCard?.allButtons;

    const updatedButtons = [
      ...buttons,
      ...(data?.paymentStats &&
      data?.paymentStats.toLowerCase() === "paid" &&
      data?.delivery?.status !== "Delivered"
        ? [
            // { key: "markAsDelivered", title: "Mark as Delivered" }
          ]
        : []),
    ];
    return {
      isDelivered: data?.delivery?.status === "Delivered",
      authenticated:
        data?.delivery?.status === "Delivered" ? data?.delivery?.status : null,
      titleButtonName:
        data?.delivery?.status === "Delivered"
          ? null
          : appCardConfig?.appCard?.addNoteButton,
      // buttons:
      //   data?.delivery?.status === "Delivered"
      //     ? []
      //     : data?.discount?.lateAssociation
      //     ? appCardConfig?.appCard?.assignEmailButtons
      //     : appCardConfig?.appCard?.allButtons,
      buttons: updatedButtons,
      accordionItems: accordionItems,
    };
  }
  private _getCostumeValueDownPayment(items: any[]) {
    let totalDownPayment = 0;
    console.log(`items----`, items);
    if (items && Array.isArray(items)) {
      for (let i = 0; i < items.length; i++) {
        totalDownPayment += parseInt(items[i].costumeValue.minDownPayment || 0);
      }
      console.log(`totalDownPayment----`, totalDownPayment);
      return totalDownPayment;
    }
    return totalDownPayment;
  }
  private formatData(data: any, entireData: any, distBoxSchedule: any) {
    const pastPurchaseArray: any = [];
    entireData.map((item: any) => {
      console.log(item),
        pastPurchaseArray.push({
          id: item?.presentation?.id,
          year: item?.presentation?.year,
          name: item?.presentation?.name,
          costumeStatus: item?.boxStatus,
          totalAmount: item?.totalAmount,
          amountPaid: item?.amountPaid,
          costumeId: item?.costumeID,
          section: item?.section?.name,
        });
    });
    const pastPurchase = {
      headers: appCardConfig.pastPurchase.headers,
      yearWiseDetails: pastPurchaseArray,
    };
    let accordionItems: any = [];
    if (this.getTableData(data, data?.items)) {
      accordionItems.push(this.getTableData(data, data?.items));
    }
    if (
      data?.payOrder?.payTxes &&
      is.existy(data?.payOrder?.payTxes) &&
      is.not.empty(data?.payOrder?.payTxes)
    ) {
      accordionItems.push(this.getInvoiceData(data?.payOrder?.payTxes));
    }
    if (is.not.empty(this.getJourneyData(data?.boxTxes)?.data)) {
      accordionItems.push(this.getJourneyData(data?.boxTxes));
    }
    return {
      pastPurchase,
      preselectedSlotId: distBoxSchedule,
      data: data,
      title: data?.items[0]?.costumeType?.name,
      isDelivered: data?.delivery?.status === "Delivered",
      authenticated:
        data?.delivery?.status === "Delivered" ? data?.delivery?.status : null,
      subtitle: data?.items[0]?.costumeType?.description,
      description: data?.note
        ? appCardConfig?.appCard?.description + data?.note
        : null,
      boxNote: data?.note ? data?.note : null,
      titleButtonName:
        data?.delivery?.status === "Delivered"
          ? null
          : appCardConfig?.appCard?.addNoteButton,
      // titleButtonName: data?.delivery?.status === 'Delivered' ? null : appCardConfig?.appCard?.addNoteButton,
      costumeTypeMinDownPayment:
        data?.items[0]?.costumeType?.minDownPayment ?? 0,
      listItems: this.getListItems(data),
      carouselItems: this.getAllSectionImages(data?.items[0]?.costumeType),
      buttons:
        data?.delivery?.status === "Delivered"
          ? []
          : data?.discount?.lateAssociation
          ? appCardConfig?.appCard?.assignEmailButtons
          : appCardConfig?.appCard?.allButtons,
      accordionItems: accordionItems,
      initialData: this.initialData(data),
      totalAmount: data?.totalAmount,
      paidAmount: data?.amountPaid.toFixed(2) ?? 0,
      userName: this.getUserName(data?.user) ?? "",
      userEmail: data?.user?.email ?? "",
      costumeID: data?.costumeID,
      boxId: data?.id,
      presentation: data?.presentation,
      section: data?.section,
      costumeValueMinDownPayment: this._getCostumeValueDownPayment(data?.items),
    };
  }
  private formatDataPast(entireData: any) {
    const pastPurchaseArray: any = [];
    entireData.map((item: any) => {
      console.log(item),
        pastPurchaseArray.push({
          id: item?.presentation?.id,
          year: item?.presentation?.year,
          name: item?.presentation?.name,
          costumeStatus: item?.boxStatus,
          totalAmount: item?.totalAmount,
          amountPaid: item?.amountPaid,
          costumeId: item?.costumeID,
          section: item?.section?.name,
        });
    });
    const pastPurchase = {
      headers: appCardConfig.pastPurchase.headers,
      yearWiseDetails: pastPurchaseArray,
    };

    return {
      pastPurchase,
    };
  }
}
